// extracted by mini-css-extract-plugin
module.exports = {"actions":"InstitutionActions_actions__Lx4wV"};